import {
  Box,
  Card,
  Grid,
  Icon,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
} from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import Chart from "react-apexcharts";
import { Download, SearchOutlined } from "@mui/icons-material";
import Card1 from "../../core/layouts/Card1";
import Card2 from "../../core/layouts/Card2";
import { API_METHOD_GET, API_METHOD_POST } from "../../config/constants";
import {
  DELETE_GROUPS_ERROR,
  DELETE_GROUPS_SUCCESS,
  FETCH_DOC_USERS_ERROR,
  FETCH_DOC_USERS_SUCCESS,
  GROUP_DATA_ERROR,
  GROUP_DATA_SUCCESS,
} from "../../store/types/billTypes";
import { useDispatch, useSelector } from "react-redux";
import {
  api_request,
  downloadFileCommon,
} from "../../store/actions/commonAction";
import { useLocation } from "react-router";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import { setBillReducer } from "../../store/actions/billActions";
import ProjectSelector from "./common/ProjectSelector";
import moment from "moment";

export default function AdmissionDashBoard() {
  const dispatch = useDispatch();
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const [dateWiseFetch, setDateWiseFetch] = React.useState(false);
  const [project, setProject] = React.useState(null);
  const users = useSelector((state) => state.bill.userDocs);
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();
  const groupDocsSuccess = useSelector((state) => state.bill.groupDocsSuccess);
  const groupDocsError = useSelector((state) => state.bill.groupDocsError);
  const deleteGroupSuccess = useSelector(
    (state) => state.bill.deleteGroupSuccess,
  );
  const deleteGroupError = useSelector((state) => state.bill.deleteGroupError);
  const projects = useSelector((state) => state.common.projectsLatest);

  const navigate = useNavigate();
  const tool = location.pathname.split("/")[1];

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (groupDocsSuccess) {
      getData();
      dispatch(
        setBillReducer({ groupDocsSuccess: false, groupDocsError: false }),
      );
    }
    if (groupDocsError) {
      alert("Internal error");
      dispatch(
        setBillReducer({ groupDocsSuccess: false, groupDocsError: false }),
      );
    }
  }, [groupDocsSuccess, groupDocsError]);

  useEffect(() => {
    if (deleteGroupSuccess) {
      getData();
      dispatch(
        setBillReducer({ deleteGroupSuccess: false, deleteGroupError: false }),
      );
    }
    if (deleteGroupError) {
      alert("Internal error");
      dispatch(
        setBillReducer({ deleteGroupSuccess: false, deleteGroupError: false }),
      );
    }
  }, [deleteGroupSuccess, deleteGroupError]);

  const getData = () => {
    console.log("start getData", { startDate, endDate, dateWiseFetch });
    dispatch(
      api_request(
        API_METHOD_GET,
        "/business/all/DocGroupList",
        {},
        {
          _defaultFilter: encodeURIComponent(
            JSON.stringify(
              startDate && endDate
                ? {
                    "$Documents.createdAt$": {
                      between: [
                        moment(startDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
                        moment(endDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
                      ],
                    },
                    userId: user?.id,
                    tool,
                    type: "basic",
                  }
                : { userId: user?.id, tool, type: "basic" },
            ),
          ),
        },
        null,
        FETCH_DOC_USERS_SUCCESS,
        FETCH_DOC_USERS_ERROR,
        true,
        false,
      ),
    );
  };

  const downloadData = () => {
    let data = users
      ?.filter((user) =>
        dateWiseFetch ? user : user?.info?.criteria?.projectId === project,
      )
      ?.map((user) => {
        let ob = {
          Course: dateWiseFetch
            ? projects?.find((p) => Number(p.id) === Number(user.fieldValue))
                ?.name
            : projects?.find((p) => p.id === project)?.name,
          Name: user?.info?.data?.["NAME OF THE CANDIDATE"],
        };
        for (let sub of user?.info?.criteria?.subjects || []) {
          ob[sub?.name] = sub?.marks;
        }
        ob["Name Check"] = user?.info?.criteria?.["Name Check"]
          ? "Pass"
          : "Fail";
        ob["Board Check"] = user?.info?.criteria?.["Board Check"]
          ? "Pass"
          : "Fail";
        ob["Eligible"] = user?.info?.criteria?.["Overall Check"]
          ? "Pass"
          : "Fail";
        return ob;
      });
    dispatch(
      downloadFileCommon({
        fileName: "admission-data.xlsx",
        body: {
          docType: "Admission Data",
          data,
        },
        path: "/document/common/excel",
      }),
    );
  };

  const deleteGroups = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/doc/groups/delete/all",
        {},
        {},
        null,
        DELETE_GROUPS_SUCCESS,
        DELETE_GROUPS_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const groupData = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/group/documents",
        {},
        {},
        null,
        GROUP_DATA_SUCCESS,
        GROUP_DATA_ERROR,
        true,
        false,
      ),
    );
  };

  const viewDocs = (row) => {
    navigate("/" + tool + "/docs/view", {
      state: {
        docGroupId: row.id,
        label: row?.info?.data?.["NAME OF THE CANDIDATE"],
      },
    });
  };

  return project || dateWiseFetch ? (
    <Box style={{ width: "100%" }}>
      <Grid container columnSpacing={3}>
        <Grid
          item
          xs={8}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h2>Admission Dashboard</h2>
        </Grid>
        <Grid xs={2}>
          {!dateWiseFetch ? (
            <ProjectSelector
              project={project}
              setProject={setProject}
              groupData={groupData}
              onlySelect={true}
              label="course"
            />
          ) : null}
        </Grid>

        <Grid xs={2} style={{ paddingTop: 12, textAlign: "right" }}>
          <CoreIconButton
            onClick={() => {
              setDateWiseFetch(false);
              setProject(null);
            }}
          >
            <Tooltip title="Clear">
              <Icon>clear</Icon>
            </Tooltip>
          </CoreIconButton>
          <CoreIconButton onClick={groupData}>
            <Tooltip title="Sync">
              <Icon>sync</Icon>
            </Tooltip>
          </CoreIconButton>
          <CoreIconButton onClick={deleteGroups}>
            <Tooltip title="Delete All">
              <Icon>delete_all</Icon>
            </Tooltip>
          </CoreIconButton>
          <CoreIconButton onClick={downloadData}>
            <Tooltip title="Download Excel">
              <Icon>download</Icon>
            </Tooltip>
          </CoreIconButton>
        </Grid>
      </Grid>
      {/* <br /> */}
      <Grid container columnSpacing={1}>
        <Grid item xs={12}>
          <Card1>
            <TableContainer style={{ height: "398px" }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {dateWiseFetch && <TableCell>Course</TableCell>}
                    <TableCell>Candidate</TableCell>
                    {Object.keys(
                      projects?.find((p) => p.id === project)?.extraInfo
                        ?.subjectMap || {},
                    ).map((sub) => (
                      <TableCell>{sub}</TableCell>
                    ))}
                    <TableCell>Board Check</TableCell>
                    <TableCell>Name Check</TableCell>
                    <TableCell>Eligible</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users
                    ?.filter((user) =>
                      dateWiseFetch
                        ? user
                        : user?.info?.criteria?.projectId === project,
                    )
                    ?.map((user) => (
                      <TableRow>
                        {dateWiseFetch && (
                          <TableCell>
                            {
                              projects?.find(
                                (p) => Number(user.fieldValue) === Number(p.id),
                              )?.name
                            }
                          </TableCell>
                        )}
                        <TableCell>
                          {user?.info?.data?.["NAME OF THE CANDIDATE"]}
                        </TableCell>
                        {Object.keys(
                          projects?.find((p) => p.id === project)?.extraInfo
                            ?.subjectMap || {},
                        ).map((sub) => (
                          <TableCell>
                            {user?.info?.criteria?.subjects?.find(
                              (s) =>
                                s?.name?.toLowerCase()?.trim() ===
                                sub?.toLowerCase()?.trim(),
                            )?.marks || 0}
                          </TableCell>
                        ))}

                        <TableCell>
                          {user?.info?.criteria?.["Board Check"] ? (
                            <Icon fontSize="small" color="success">
                              check_circle
                            </Icon>
                          ) : (
                            <Icon fontSize="small" color="error">
                              cancel
                            </Icon>
                          )}
                        </TableCell>
                        <TableCell>
                          {user?.info?.criteria?.["Name Check"] ? (
                            <Icon fontSize="small" color="success">
                              check_circle
                            </Icon>
                          ) : (
                            <Icon fontSize="small" color="error">
                              cancel
                            </Icon>
                          )}
                        </TableCell>
                        <TableCell>
                          {user?.info?.criteria?.["Overall Check"] ? (
                            <Icon fontSize="small" color="success">
                              check_circle
                            </Icon>
                          ) : (
                            <Icon fontSize="small" color="error">
                              cancel
                            </Icon>
                          )}
                        </TableCell>
                        <TableCell>
                          <CoreIconButton
                            onClick={() => viewDocs(user)}
                            size="small"
                          >
                            <Icon fontSize="small" color="secondary">
                              chevron_right
                            </Icon>
                          </CoreIconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card1>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <ProjectSelector
      setProject={setProject}
      groupData={groupData}
      label="course"
      startDate={startDate}
      setStartDate={setStartDate}
      endDate={endDate}
      setEndDate={setEndDate}
      setDateWiseFetch={setDateWiseFetch}
      dateFilter={true}
      getData={getData}
    />
  );
}
